import * as services from "../services/api";
import {
  SET_USER_IMPORTS,
  UPDATE_USER_IMPORTS,
  REQUEST_USER_IMPORTS,
  FACEBOOK,
  INSTAGRAM,
  PROCESSING,
  FAILURE,
  SUCCESS
} from "./types";

const importStates = {
  1: PROCESSING,
  2: FAILURE,
  3: PROCESSING,
  4: SUCCESS,
  5: PROCESSING
};

export const importTypes = {
  1: FACEBOOK,
  2: INSTAGRAM
};

export default {
  namespaced: true,
  state: {
    imports: [],
    loading: false
  },
  mutations: {
    [REQUEST_USER_IMPORTS](state) {
      state.loading = true;
    },
    [SET_USER_IMPORTS](state, imports) {
      state.loading = false;
      state.imports = imports;
    },
    [UPDATE_USER_IMPORTS](state, payload) {
      state.imports = [...state.imports, payload];
    }
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    allImports(state) {
      return state.imports
        .map(item => ({
          ...item,
          status: importStates[item.status],
          source: importTypes[item.import_type],
          created: new Date(item.create_date),
          ended: item.end_date ? new Date(item.end_date) : null
        }))
        .sort((a, b) => b.created - a.created);
    }
  },
  actions: {
    async importProfile({ commit }, { profileLink, spaceId, importType }) {
      return services
        .importFacebookProfile(profileLink, spaceId, importType)
        .then(data => {
          commit(UPDATE_USER_IMPORTS, {
            task_id: data.tracking_id,
            import_type: importType,
            create_date: new Date(),
            end_date: null,
            status: 1
          });
        });
    },
    async getUserImports({ commit }) {
      commit(REQUEST_USER_IMPORTS);
      services.getUserImports().then(imports => {
        commit(SET_USER_IMPORTS, imports);

      });
      

    }
  }
};
